/**
 * Checks for textareas with a maxlength attribute and adds a character count display.
 */
const addTextareaCharacterCount = (textarea) => {
    const maxLength = textarea.getAttribute("maxlength");

    // Create the container div for character count
    const counterDiv = document.createElement("div");
    counterDiv.classList.add("freeform-fieldtype-textarea-character-limit");
    counterDiv.innerHTML = `
      <span class="freeform-fieldtype-textarea-character-limit__text">Beschrijf in maximaal ${maxLength} karakters:</span>
      <span class="freeform-fieldtype-textarea-character-limit__count"><span id="currentLength">0</span>/${maxLength}</span>
    `;

    // Style the counter div (optional)
    counterDiv.style.marginTop = "5px";
    counterDiv.style.fontSize = "0.9em";
    counterDiv.style.color = "#555";

    // Insert the counterDiv after the textarea
    const parentDiv = textarea.closest("div[data-field-container]");
    if (parentDiv) {
      parentDiv.appendChild(counterDiv);
    }

    // Update character count on input
    textarea.addEventListener("input", () => {
      const currentLength = textarea.value.replace(/\n/g, "\n").length;
      counterDiv.querySelector("#currentLength").textContent = currentLength;
    });
};

/**
 * Prepares numbered lists by ensuring consistent font size for list items,
 * and adding responsiveness for window resize events.
 */
const prepareTextareaMaxLengthList = () => {
    // Select all unordered and ordered lists within [data-type="numberedListBlocks"]
    const textareas = document.querySelectorAll("textarea[maxlength]");

    textareas.forEach((textarea) => {
        console.log({textarea})
        addTextareaCharacterCount(textarea)
    })
};

// Export the function as the default export
export default prepareTextareaMaxLengthList;
